import { render, staticRenderFns } from "./walimanage.vue?vue&type=template&id=620a4014&scoped=true&"
import script from "./walimanage.vue?vue&type=script&lang=js&"
export * from "./walimanage.vue?vue&type=script&lang=js&"
import style0 from "./walimanage.vue?vue&type=style&index=0&id=620a4014&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a4014",
  null
  
)

export default component.exports